export const conditionFilter = function (
  key: string,
  value: string,
  type: number = 4,
  list: Array<any> = []
) {
  if (value) {
    return [
      ...list,
      {
        key: key,
        value: value,
        type: type
      }
    ];
  } else {
    return list;
  }
};

export function NumberRule(rule, value, callback) {
  const val = Number(value);
  if (value === "") {
    callback(new Error(this.$t("Basic.required_msg")));
  } else if (isNaN(val)) {
    callback(new Error(this.$t("Basic.required_num_msg")));
  } else if (val === 0) {
    callback(new Error(this.$t("Basic.required_num_0")));
  } else {
    callback();
  }
}

export function skuRule(rule, val, callback) {
  const reg = /^[0-9a-zA-Z-]{1,}$/;
  if (val === "") {
    callback(new Error(this.$t("Basic.required_msg")));
  } else if (val.length >= 20) {
    callback(new Error(this.$t("Basic.required_20_char")));
  } else if (!reg.test(val)) {
    callback(new Error(this.$t("Basic.required_number_letter_dashes")));
  } else {
    callback();
  }
}

export function skuNotRequiredRule(rule, val, callback) {
  const reg = /^""|[0-9a-zA-Z-]{0,}$/;
  if (!val) {
    val = "";
  }
  if (val.length >= 20) {
    callback(new Error(this.$t("Basic.required_20_char")));
  } else if (!reg.test(val)) {
    callback(new Error(this.$t("Basic.required_number_letter_dashes")));
  } else {
    callback();
  }
}

export function NumberPrice(rule, value, callback) {
  let val = Number(value);
  if (value === undefined || value === "") {
    value = null;
    callback();
  } else if (isNaN(val)) {
    callback(new Error(this.$t("Basic.required_num_msg")));
  } else if (val < 0) {
    callback(new Error(this.$t("Basic.required_num_0")));
  } else {
    callback();
  }
}

export function convertObjtoStr(obj) {
  let str = "";
  for (const key in obj) {
    str = str + key + "=" + obj[key] + "&";
  }
  str = str.substring(0, str.length - 1);
  return str;
}

export function getLocalStorage(key, isJson = 0) {
  return isJson
    ? JSON.parse(localStorage.getItem(key))
    : localStorage.getItem(key);
}

export const productConditionFilter = function (
  key: string,
  value: any,
  type: number = 4,
  list: Array<any> = []
) {
  if (value || value === 0) {
    if (["onboardTime", "createTime"].includes(key)) {
      return [
        ...list,
        {
          key: key,
          value: value[0],
          type: 2
        },
        {
          key: key,
          value: value[1],
          type: 3
        }
      ];
    } else if (["brandCode", "categoryCode"].includes(key)) {
      return [
        ...list,
        {
          key: key,
          ext4: value
        }
      ];
    } else {
      let item: any = {
        key: key,
        value: value
      };
      if (type !== -1) {
        item.type = type;
      }
      return [
        ...list,
        {
          ...item
        }
      ];
    }
  } else {
    return list;
  }
};
export function skuNumberRule(rule, val, callback) {
  const reg = /^[0-9a-zA-Z-_]{1,}$/;
  if (val === "") {
    callback(new Error(this.$t("Basic.required_msg")));
  } else if (val.length > 100) {
    callback(new Error(this.$t("Basic.required_100_char")));
  } else if (!reg.test(val)) {
    callback(new Error(this.$t("Basic.required_number_letter_dashes")));
  } else {
    callback();
  }
}
export function skuExtCodeRequiredRule(rule, val, callback) {
  const reg = /^[0-9a-zA-Z-_]{0,}$/;
  if (!val) {
    val = "";
  }
  if (val.length > 50) {
    callback(new Error(this.$t("Basic.required_50_char")));
  } else if (!reg.test(val)) {
    callback(new Error(this.$t("Basic.required_number_letter_dashes")));
  } else {
    callback();
  }
}

export const fomatLocaletoArray = function (languageList, data, key) {
  let arr = [];
  languageList.forEach(_ => {
    arr.push({
      key,
      value: data[_.value],
      locale: _.value
    });
  });
  return arr;
};
